type Props = Record<string, unknown>;

function safeAnalytics() {
  return typeof window !== "undefined" ? window.analytics : undefined;
}

function cleanProps(props?: Props): Props | undefined {
  if (!props) return undefined;
  const out: Props = {};
  for (const [key, value] of Object.entries(props)) {
    if (value !== undefined && value !== null && value !== "") {
      out[key] = value;
    }
  }
  return Object.keys(out).length ? out : undefined;
}

export function track(event: string, properties?: Props) {
  try {
    const analytics = safeAnalytics();
    if (!analytics?.track) return;
    analytics.track(event, cleanProps(properties));
  } catch {
    // never break UX for analytics
  }
}

export function identify(userId: string, traits?: Props) {
  try {
    const analytics = safeAnalytics();
    if (!analytics?.identify) return;
    analytics.identify(userId, cleanProps(traits));
  } catch {
    // ignore
  }
}

export function page(name?: string, properties?: Props) {
  try {
    const analytics = safeAnalytics();
    if (!analytics?.page) return;
    if (name) {
      analytics.page(name, cleanProps(properties));
    } else {
      analytics.page(cleanProps(properties));
    }
  } catch {
    // ignore
  }
}

export function reset() {
  try {
    const analytics = safeAnalytics();
    if (!analytics?.reset) return;
    analytics.reset();
  } catch {
    // ignore
  }
}

export function trackMerchant(event: string, properties?: Props) {
  track(event, cleanProps(properties));
}
